import { ModalService } from "src/app/core/services/modal.service";
import { TranslateService } from "@ngx-translate/core";
import { Router } from "@angular/router";
import { Injectable, NgZone } from "@angular/core";
import { HttpErrorResponse, HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from "@angular/common/http";
import { Observable, of } from "rxjs";
import { map, catchError, timeout } from "rxjs/operators";
import * as $ from "jquery";
import { finalize } from "rxjs/operators";
import { AuthService } from "./auth.service";
import { Util } from "src/app/shared/helpers/util";
import { AES_INFO } from "src/app/shared/constants/common.const";
import { environment } from "src/environments/environment";
import sha256 from 'crypto-js/sha256';

declare let CryptoJS: any;

@Injectable({
  providedIn: "root",
})
export class AuthInterceptor implements HttpInterceptor {
  private util = new Util();
  private timeoutmillsec = 120000;
  private longtimeApis = ["PME0621"];

  constructor(
    private authService: AuthService,
    private translate: TranslateService,
    private router: Router,
    private zone: NgZone,
    private modal: ModalService,
  ) { }

  decrypt(plaintext, password) {
    return CryptoJS.AES.decrypt(
      {
        ciphertext: CryptoJS.enc.Hex.parse(plaintext.substring(32)),
      },
      CryptoJS.enc.Hex.parse(CryptoJS.SHA1(password).toString().substring(0, 32)),
      // CryptoJS.enc.Hex.parse(sha256(password).toString().substring(0, 64)),
      {
        iv: CryptoJS.enc.Hex.parse(plaintext.substring(0, 32)),
      }
    ).toString(CryptoJS.enc.Utf8);
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // tslint:disable-next-line: prefer-for-of
    for (let idx = 0; idx < this.longtimeApis.length; idx++) {
      if (req.url.indexOf(this.longtimeApis[idx]) > 0) {
        environment.production
          ? (() => "")()
          : this.timeoutmillsec = 2 * 60 * 1000;
        break;
      }
    }
    // Ignore path
    if (
      req.url.indexOf("/assets") === -1 &&
      req.url.indexOf("/security_check") === -1 &&
      req.url.indexOf("/RSA") === -1 &&
      req.url.indexOf("/AES") === -1 &&
      req.url.indexOf("/PME0621") === -1 &&
      req.url.indexOf("/PME0611") === -1 &&
      req.url.indexOf("/PME0113") === -1 &&
      req.url.indexOf("/PME0613") === -1 &&
      req.url.indexOf("/PME0612") === -1
    ) {
      if (!this.authService.hasSession()) {
        this.showErrMsg("NOTLOGIN");
        return;
      }
    }

    return next.handle(req).pipe(
      timeout(this.timeoutmillsec),
      map((event) => {
        let apiname = req.url.split(environment.OMMServer.context)[1];

        if (!apiname) {
          apiname = req.url;
        }

        if (environment.encryptionUse) {
          const aesInfo: any = this.util.getSecureStorage(AES_INFO.STORE) || {};

          if (
            event instanceof HttpResponse &&
            event.body.body &&
            typeof event.body.body === "string"
          ) {
            event = event.clone({
              body: {
                header: event.body.header,
                body: JSON.parse(this.decrypt(event.body.body, aesInfo.aesKey)),
              },
            });
          }
        }

        if (event instanceof HttpResponse) {
        }

        return event;
      }),

      finalize(() => {
        environment.production ? (() => "")() : $("div.loading").addClass("none");
      }),

      catchError((error: HttpErrorResponse) => {
        $("div.loading").addClass("none");
        let httpErrorCode;
        if (error.status) {
          httpErrorCode = error.status;
        } else {
          httpErrorCode = "999999";
        }
        return of(
          new HttpResponse({
            body: {
              header: { result: false, resultCode: httpErrorCode },
              body: {},
            },
          })
        );
      }) as any
    );
  }

  showErrMsg(msgKey: string) {
    this.translate.get("COMMON.ERROR").subscribe((message) => {
      const commonMsg = this.translate.instant("COMMON");
      if (msgKey === "NOTLOGIN") {
        $("kendo-dialog").remove();
        this.modal.alert({
          content: commonMsg.LABEL.AUTO_LOGOUT1 + '\n' + commonMsg.LABEL.AUTO_LOGOUT2 + '\n' + commonMsg.LABEL.AUTO_LOGOUT3,
          callback: () => {
            this.zone.run(() => this.router.navigate(["/login"]));
          },
        });
      } else {
        this.modal.alert({
          content: message[msgKey],
        });
      }
    });
  }

}
